import type { WorkspaceSettings } from '../core/models/Workspace'
import type { AppearanceConfig } from '../components/MainMenu/sections/admin/EnvironmentConfig/types/EnvironmentConfig.types'
import { defaultEnvironmentConfig } from '../components/MainMenu/sections/admin/EnvironmentConfig/utils/defaultConfigs'
import {
  DEFAULT_SEVV_THEME_TOKENS,
  mergeThemeTokens,
  parseJsonField,
  themeTokensFromLegacyUrls,
  type SevvThemeTokens,
} from './sevvThemeTokenModel'

function mergeAppearance(base: AppearanceConfig, partial: Partial<AppearanceConfig> | null): AppearanceConfig {
  if (!partial) return base
  return {
    theme: { ...base.theme, ...partial.theme },
    typography: { ...base.typography, ...partial.typography },
    animations: {
      ...base.animations,
      ...partial.animations,
    },
    localization: { ...base.localization, ...partial.localization },
  }
}

export function resolveAppearanceFromWorkspace(settings: WorkspaceSettings | null): AppearanceConfig {
  const base = defaultEnvironmentConfig.appearance
  if (!settings?.appearance_config) return base
  const partial = parseJsonField<Partial<AppearanceConfig>>(settings.appearance_config, {})
  return mergeAppearance(base, partial)
}

export function resolveThemeTokensFromWorkspace(settings: WorkspaceSettings | null): SevvThemeTokens {
  let merged = mergeThemeTokens(DEFAULT_SEVV_THEME_TOKENS, themeTokensFromLegacyUrls(settings?.urls))
  if (settings?.theme_tokens) {
    const parsed = parseJsonField<Partial<SevvThemeTokens>>(settings.theme_tokens, {})
    merged = mergeThemeTokens(merged, parsed)
  }
  return merged
}

export function resolveThemeMode(
  appearance: AppearanceConfig,
  prefersDark: boolean
): 'light' | 'dark' {
  if (appearance.theme.mode === 'auto') {
    return prefersDark ? 'dark' : 'light'
  }
  return appearance.theme.mode === 'dark' ? 'dark' : 'light'
}
